import { QuestionBase } from './question-base.model';

export class CheckboxQuestion extends QuestionBase<string> {
   controlType = 'checkbox';
   text: string;
   htmlText: string;
   id: string;
   disabled: boolean;
   visible: string;
   options: any;
   type: any;
   view_key: any
   is_rich_text: boolean;
   is_label_required: boolean;
   format: any;
   getterKey: any;
   getterValue: any;
   calculated_field_type: string;
   calculation_formula: any;
   select_defination: any;
   MultiCkbLayout: any;

   constructor(options: {} = {}) {
      super(options);
      this.text = options['text'] || '';
      this.htmlText = options['htmlText'] || '';
      this.value = options['value'] || false;
      this.id = options['id'];
      this.disabled = (options['disabled'] == undefined) ? false : options['disabled'];
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.options = options['options'];
      this.type = options['type'];
      this.is_rich_text = (options['is_rich_text'] == undefined) ? false : options['is_rich_text'];
      this.is_label_required = (options['is_label_required'] == undefined) ? false : options['is_label_required'];
      this.conditions = options['conditions'];
      this.view_key = options['view_key'];
      this.format = options['format'] || false;
      this.getterKey = options['getterKey'] || 'id';
      this.getterValue = options['getterValue'] || 'value';
      this.calculated_field_type = options['calculated_field_type'] || '';
      this.calculation_formula = options['calculation_formula'];
      this.select_defination = options['select_defination'] || '';
      this.MultiCkbLayout = options['MultiCkbLayout'] || '';
   }
}